<template>
  <div id="keypad" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="keypad" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body1">
          <div class="keyboard">
            <!-- First Row -->
            <div class="keyboard__row" v-if="!symbolsActive">
              <div class="key--letter" @click="insertChar(shiftActive ? 'Q' : 'q')">Q</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'W' : 'w')">W</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'E' : 'e')">E</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'R' : 'r')">R</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'T' : 't')">T</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'Y' : 'y')">Y</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'U' : 'u')">U</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'I' : 'i')">I</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'O' : 'o')">O</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'P' : 'p')">P</div>
              <div class="key--letter"></div>
              <div class="key--letter"></div>
              <div class="key--letter" @click="backspace()">
                <svg style="stroke: white; fill:none;height:36px; width:23px; stroke-width:18px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M576 384C576 419.3 547.3 448 512 448H205.3C188.3 448 172 441.3 160 429.3L9.372 278.6C3.371 272.6 0 264.5 0 256C0 247.5 3.372 239.4 9.372 233.4L160 82.75C172 70.74 188.3 64 205.3 64H512C547.3 64 576 92.65 576 128V384zM271 208.1L318.1 256L271 303C261.7 312.4 261.7 327.6 271 336.1C280.4 346.3 295.6 346.3 304.1 336.1L352 289.9L399 336.1C408.4 346.3 423.6 346.3 432.1 336.1C442.3 327.6 442.3 312.4 432.1 303L385.9 256L432.1 208.1C442.3 199.6 442.3 184.4 432.1 175C423.6 165.7 408.4 165.7 399 175L352 222.1L304.1 175C295.6 165.7 280.4 165.7 271 175C261.7 184.4 261.7 199.6 271 208.1V208.1z"/>
                </svg>
              </div>
            </div>
            
            <!-- Numbers/Symbols First Row -->
            <div class="keyboard__row" v-if="symbolsActive">
              <div class="key--letter" @click="insertChar('1')">1</div>
              <div class="key--letter" @click="insertChar('2')">2</div>
              <div class="key--letter" @click="insertChar('3')">3</div>
              <div class="key--letter" @click="insertChar('4')">4</div>
              <div class="key--letter" @click="insertChar('5')">5</div>
              <div class="key--letter" @click="insertChar('6')">6</div>
              <div class="key--letter" @click="insertChar('7')">7</div>
              <div class="key--letter" @click="insertChar('8')">8</div>
              <div class="key--letter" @click="insertChar('9')">9</div>
              <div class="key--letter" @click="insertChar('0')">0</div>
              <div class="key--letter"></div>
              <div class="key--letter"></div>
              <div class="key--letter" @click="backspace()">
                <svg style="stroke: white; fill:none;height:36px; width:23px; stroke-width:18px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M576 384C576 419.3 547.3 448 512 448H205.3C188.3 448 172 441.3 160 429.3L9.372 278.6C3.371 272.6 0 264.5 0 256C0 247.5 3.372 239.4 9.372 233.4L160 82.75C172 70.74 188.3 64 205.3 64H512C547.3 64 576 92.65 576 128V384zM271 208.1L318.1 256L271 303C261.7 312.4 261.7 327.6 271 336.1C280.4 346.3 295.6 346.3 304.1 336.1L352 289.9L399 336.1C408.4 346.3 423.6 346.3 432.1 336.1C442.3 327.6 442.3 312.4 432.1 303L385.9 256L432.1 208.1C442.3 199.6 442.3 184.4 432.1 175C423.6 165.7 408.4 165.7 399 175L352 222.1L304.1 175C295.6 165.7 280.4 165.7 271 175C261.7 184.4 261.7 199.6 271 208.1V208.1z"/>
                </svg>
              </div>
            </div>

            <!-- Second Row -->
            <div class="keyboard__row" v-if="!symbolsActive">
              <div class="key--letter" @click="insertChar(shiftActive ? 'A' : 'a')">A</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'S' : 's')">S</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'D' : 'd')">D</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'F' : 'f')">F</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'G' : 'g')">G</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'H' : 'h')">H</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'J' : 'j')">J</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'K' : 'k')">K</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'L' : 'l')">L</div>
              <div class="key--letter"></div>
              <div class="key--letter"></div>
              <div class="key--bottom-right key--word key--w3" @click="handleEnter">
                <span>enter</span>
              </div>
            </div>
            
            <!-- Numbers/Symbols Second Row -->
            <div class="keyboard__row" v-if="symbolsActive">
              <div class="key--letter" @click="insertChar('@')">@</div>
              <div class="key--letter" @click="insertChar('#')">#</div>
              <div class="key--letter" @click="insertChar('$')">$</div>
              <div class="key--letter" @click="insertChar('%')">%</div>
              <div class="key--letter" @click="insertChar('&')">&</div>
              <div class="key--letter" @click="insertChar('*')">*</div>
              <div class="key--letter" @click="insertChar('-')">-</div>
              <div class="key--letter" @click="insertChar('+')">+</div>
              <div class="key--letter" @click="insertChar('(')">(</div>
              <div class="key--letter" @click="insertChar(')')">)</div>
              <div class="key--letter"></div>
              <div class="key--bottom-right key--word key--w3" @click="handleEnter">
                <span>enter</span>
              </div>
            </div>

            <!-- Third Row -->
            <div class="keyboard__row" v-if="!symbolsActive">
              <div class="key--letter key--word key--w2" @click="toggleShift">
                <span>shift</span>
              </div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'Z' : 'z')">Z</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'X' : 'x')">X</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'C' : 'c')">C</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'V' : 'v')">V</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'B' : 'b')">B</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'N' : 'n')">N</div>
              <div class="key--letter" @click="insertChar(shiftActive ? 'M' : 'm')">M</div>
              <div class="key--letter" @click="insertChar(',')">,</div>
              <div class="key--letter" @click="insertChar('.')">.</div>
              <div class="key--letter" @click="insertChar('/')">/</div>
              <div class="key--bottom-right key--word key--w2" @click="toggleShift">
                <span>shift</span>
              </div>
            </div>
            
            <!-- Numbers/Symbols Third Row -->
            <div class="keyboard__row" v-if="symbolsActive">
              <div class="key--letter key--word key--w2" @click="toggleSymbols">
                <span>ABC</span>
              </div>
              <div class="key--letter" @click="insertChar('!')">!</div>
              <div class="key--letter" @click="insertChar('?')">?</div>
              <div class="key--letter" @click="insertChar('\'')">'</div>
              <div class="key--letter" @click="insertChar(':')">:</div>
              <div class="key--letter" @click="insertChar(';')">;</div>
              <div class="key--letter" @click="insertChar('_')">_</div>
              <div class="key--letter" @click="insertChar('=')">=</div>
              <div class="key--letter" @click="insertChar('[')">[</div>
              <div class="key--letter" @click="insertChar(']')">]</div>
              <div class="key--bottom-right key--word key--w2" @click="toggleSymbols">
                <span>ABC</span>
              </div>
            </div>

            <!-- Fourth Row -->
            <div class="keyboard__row keyboard__row--h3">
              <div class="key--letter key--word key--w2" @click="toggleSymbols">
                <span v-if="!symbolsActive">&123</span>
                <span v-else>ABC</span>
              </div>
              <div class="key--letter key--word key--w3">
                <span>control</span>
              </div>
              <div class="key--double key--right key--space" @click="insertChar(' ')">
                &nbsp;
              </div>
              <div class="key--letter key--word key--w3" @click="insertChar('\'')">
                <span>'</span>
              </div>
              <div class="key--letter key--word key--w3" @click="insertChar(':-)')">
                <span>:-)</span>
              </div>
              <div class="key--letter key--word key--w5">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['update:value', 'cancel', 'enter-pressed'],
  name: 'KeypadComponent',
  props: {
    targetInput: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localTargetInput: this.targetInput,
      shiftActive: false,
      symbolsActive: false
    }
  },
  methods: {
    handleEnter() {
      this.$emit('update:value', this.localTargetInput.value); 
      this.$emit('cancel'); 
    },
    setTargetInput(input) {
      this.localTargetInput = input;
    },
    insertChar(char) {
  if (!this.localTargetInput) return;
  
  const input = this.localTargetInput;
  input.value = input.value + char;
  
  const newPosition = input.value.length;
  input.selectionStart = input.selectionEnd = newPosition;
  
  input.dispatchEvent(new Event('input'));
  
  if (this.shiftActive && char.length === 1 && /[a-zA-Z]/.test(char)) {
    this.shiftActive = false;
  }
},
backspace() {
  if (!this.localTargetInput) return;
  
  const input = this.localTargetInput;
  const currentValue = input.value;
  
  if (currentValue.length > 0) {
    // Remove last character
    input.value = currentValue.substring(0, currentValue.length - 1);
    
    // Set cursor position to the end
    input.selectionStart = input.selectionEnd = input.value.length;
    input.dispatchEvent(new Event('input'));
  }
},
    toggleShift() {
      this.shiftActive = !this.shiftActive;
    },
    toggleSymbols() {
      this.symbolsActive = !this.symbolsActive;
      // Reset shift when switching to symbols
      if (this.symbolsActive) {
        this.shiftActive = false;
      }
    }
  }
}
</script>